// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import Classnames from "classnames";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Fresnel$PrezzeeRibbon from "../../../bindings/Fresnel/Fresnel.bs.js";
import * as MenuToggle$PrezzeeRibbon from "../../personal/MenuToggle/MenuToggle.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";
import * as ReactResponsive$PrezzeeRibbon from "../../../bindings/ReactResponsive/ReactResponsive.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as TopNavigationBar__Background$PrezzeeRibbon from "./TopNavigationBar__Background.bs.js";

function Component(T) {
  var Background = TopNavigationBar__Background$PrezzeeRibbon.Component(T);
  var slideIn = BsCssJs$PrezzeeRibbon.keyframes([[
          100,
          [BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.px(0))]
        ]]);
  var slideOut = BsCssJs$PrezzeeRibbon.keyframes([[
          0,
          [BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(-50))]
        ]]);
  var slideAnimation = function (menuOpen) {
    return BsCssJs$PrezzeeRibbon.style([
                BsCssJs$PrezzeeRibbon.position("absolute"),
                BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(16)),
                BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(-50)),
                BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
                menuOpen ? BsCssJs$PrezzeeRibbon.animation(500, undefined, undefined, undefined, "forwards", undefined, undefined, slideIn) : BsCssJs$PrezzeeRibbon.animation(500, undefined, undefined, undefined, "backwards", undefined, undefined, slideOut)
              ]);
  };
  var navWrapper = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.backgroundColor(T.backgroundColor),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, [
              BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(30)),
              BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(30))
            ]),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [
              BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(20)),
              BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(20))
            ])
      ]);
  var navBar = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.display("flex"),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [BsCssJs$PrezzeeRibbon.flexDirection(BsCssJs$PrezzeeRibbon.column)]),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, [
              BsCssJs$PrezzeeRibbon.flexDirection(BsCssJs$PrezzeeRibbon.row),
              BsCssJs$PrezzeeRibbon.alignItems("stretch")
            ])
      ]);
  var menuToggle = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(0)),
        BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.px(16))
      ]);
  var logoMenuBlock = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.display("flex"),
        BsCssJs$PrezzeeRibbon.flexGrow(0),
        BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(66)),
        BsCssJs$PrezzeeRibbon.alignItems("center"),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [BsCssJs$PrezzeeRibbon.position("relative")])
      ]);
  var logoAuthBlock = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.display("flex"),
        BsCssJs$PrezzeeRibbon.justifyContent("spaceBetween"),
        BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
        BsCssJs$PrezzeeRibbon.flexGrow(0),
        BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(66)),
        BsCssJs$PrezzeeRibbon.alignItems("center"),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [
              BsCssJs$PrezzeeRibbon.position("relative"),
              BsCssJs$PrezzeeRibbon.marginLeft(T.logoBlockMargin)
            ])
      ]);
  var prezzeeLogo = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.flexGrow(1),
        BsCssJs$PrezzeeRibbon.display("flex"),
        BsCssJs$PrezzeeRibbon.justifyContent(T.logoPosition),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.justifyContent("center")])
      ]);
  var navigationAuthBlock = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.display("flex"),
        BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))
      ]);
  var menuBlock = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.display("none"),
        BsCssJs$PrezzeeRibbon.justifyContent("flexStart"),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, [
              BsCssJs$PrezzeeRibbon.flexGrow(1),
              BsCssJs$PrezzeeRibbon.display("flex")
            ]),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(16))])
      ]);
  var menuBlockWrapper = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.display("block"),
        BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
        BsCssJs$PrezzeeRibbon.overflow("auto"),
        BsCssJs$PrezzeeRibbon.position("relative")
      ]);
  var authBlock = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.display("none"),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.largeScreen, [
              BsCssJs$PrezzeeRibbon.flexGrow(0),
              BsCssJs$PrezzeeRibbon.display("flex"),
              BsCssJs$PrezzeeRibbon.alignItems("center")
            ]),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [
              BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
              BsCssJs$PrezzeeRibbon.justifyContent("flexStart"),
              BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(16)),
              BsCssJs$PrezzeeRibbon.borderTopWidth(BsCssJs$PrezzeeRibbon.px(1)),
              BsCssJs$PrezzeeRibbon.borderTopStyle("solid"),
              BsCssJs$PrezzeeRibbon.borderTopColor(Theme__Color$PrezzeeRibbon.Personal.paleDivider),
              BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.flexGrow(1)])
            ])
      ]);
  var loggedInBorder = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.borderLeft(BsCssJs$PrezzeeRibbon.px(1), "solid", Theme__Color$PrezzeeRibbon.Personal.paleGrey)]);
  var regionPickerBlock = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.flexGrow(1),
        BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(100)),
        BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(28)),
        BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.charcoal),
        BsCssJs$PrezzeeRibbon.display("none")
      ]);
  var displayVisible = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.display("block"))]);
  var fullHeight = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.position(BsCssJs$PrezzeeRibbon.relative),
        BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.vh(100))
      ]);
  var mobileAndTabletOnly = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.display("none"),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [
              BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.display("block")),
              BsCssJs$PrezzeeRibbon.zIndex(10)
            ])
      ]);
  var mobileLogout = BsCssJs$PrezzeeRibbon.style([
        Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
        BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.primaryRed),
        BsCssJs$PrezzeeRibbon.display("flex"),
        BsCssJs$PrezzeeRibbon.justifyContent("center"),
        BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(20)),
        BsCssJs$PrezzeeRibbon.textDecoration("underline"),
        BsCssJs$PrezzeeRibbon.cursor("pointer")
      ]);
  var Styles = {
    slideIn: slideIn,
    slideOut: slideOut,
    slideAnimation: slideAnimation,
    navWrapper: navWrapper,
    navBar: navBar,
    menuToggle: menuToggle,
    logoMenuBlock: logoMenuBlock,
    logoAuthBlock: logoAuthBlock,
    prezzeeLogo: prezzeeLogo,
    navigationAuthBlock: navigationAuthBlock,
    menuBlock: menuBlock,
    menuBlockWrapper: menuBlockWrapper,
    authBlock: authBlock,
    loggedInBorder: loggedInBorder,
    regionPickerBlock: regionPickerBlock,
    displayVisible: displayVisible,
    fullHeight: fullHeight,
    mobileAndTabletOnly: mobileAndTabletOnly,
    mobileLogout: mobileLogout
  };
  var TopNavigationBar$Component = function (props) {
    var onMenuChange = props.onMenuChange;
    var className = props.className;
    var closeMenuObservable = props.closeMenuObservable;
    var authBlock = props.authBlock;
    var className$1 = className !== undefined ? className : "";
    var tabletOrMobile = ReactResponsive$PrezzeeRibbon.useMediaQuery(Theme__Responsive$PrezzeeRibbon.belowLargeScreen);
    var match = React.useState(function () {
          return false;
        });
    var setMenuOpen = match[1];
    var menuOpen = match[0];
    var display = menuOpen ? displayVisible : "";
    var fullHeight$1 = menuOpen ? fullHeight : "";
    var disableWindowScroll = function (isDisabled) {
      document.documentElement.style.setProperty("touch-action", isDisabled ? "none" : "");
      document.documentElement.style.setProperty("overflow", isDisabled ? "hidden" : "");
    };
    var onMenuClick = function (param) {
      if (onMenuChange !== undefined) {
        Curry._1(onMenuChange, !menuOpen);
      }
      Curry._1(setMenuOpen, (function (param) {
              return !menuOpen;
            }));
    };
    var closeMenu = function (param) {
      if (onMenuChange !== undefined) {
        Curry._1(onMenuChange, false);
      }
      Curry._1(setMenuOpen, (function (param) {
              return false;
            }));
    };
    var logoutButton = props.isLoggedIn ? JsxRuntime.jsx("div", {
            children: "Log out",
            className: mobileLogout,
            onClick: props.onLogoutClick
          }) : null;
    var authMenu = authBlock !== undefined ? Caml_option.valFromOption(authBlock) : null;
    var navigationAuthBlock$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
                  children: props.navigationBlock,
                  className: Classnames([
                        menuBlock,
                        display
                      ])
                }),
            JsxRuntime.jsxs(Fresnel$PrezzeeRibbon.Media.make, {
                  lessThan: "rbLargeDesktop",
                  children: [
                    props.regionPicker,
                    logoutButton
                  ],
                  className: Classnames([
                        regionPickerBlock,
                        display
                      ])
                })
          ]
        });
    React.useEffect((function () {
            Curry._1(closeMenuObservable.subscribe, closeMenu);
            return (function (param) {
                      Curry._1(closeMenuObservable.unsubscribe, closeMenu);
                    });
          }), []);
    React.useEffect((function () {
            if (menuOpen && !tabletOrMobile) {
              Curry._1(setMenuOpen, (function (param) {
                      return false;
                    }));
            }
            
          }), [tabletOrMobile]);
    React.useEffect((function () {
            disableWindowScroll(menuOpen);
          }), [menuOpen]);
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                                            lessThan: "rbLargeDesktop",
                                            children: JsxRuntime.jsx(MenuToggle$PrezzeeRibbon.make, {
                                                  isOpen: menuOpen,
                                                  onClick: onMenuClick
                                                }),
                                            className: Classnames([
                                                  mobileAndTabletOnly,
                                                  menuToggle
                                                ])
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: props.logo,
                                                    className: prezzeeLogo
                                                  }),
                                              authMenu
                                            ],
                                            className: logoAuthBlock
                                          })
                                    ],
                                    className: logoMenuBlock
                                  }),
                              JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                                    lessThan: "rbLargeDesktop",
                                    children: JsxRuntime.jsx("div", {
                                          children: navigationAuthBlock$1,
                                          className: slideAnimation(menuOpen)
                                        }),
                                    className: Classnames([menuBlockWrapper])
                                  }),
                              JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                                    greaterThanOrEqual: "rbLargeDesktop",
                                    children: navigationAuthBlock$1,
                                    className: navigationAuthBlock
                                  })
                            ]
                          }),
                      className: Classnames([
                            navBar,
                            fullHeight$1
                          ]),
                      style: {
                        maxHeight: "100dvh"
                      }
                    }),
                className: Classnames([
                      navWrapper,
                      className$1
                    ])
              });
  };
  return {
          Background: Background,
          StaticBackground: undefined,
          FadeBackground: undefined,
          Styles: Styles,
          make: TopNavigationBar$Component
        };
}

export {
  Component ,
}
/* react Not a pure module */
